import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllGiftsUser = async ()=>{
    const response = await axios.get(buildApiUrl('marketing/getAllGifts/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllGiftsUser = data;

    //console.log('Сервер вернул данные по Gifts ---- ',response.data);


    return AllGiftsUser;
};


const setActiveGifts = async (id,val)=>{
    const response = await axios.post(buildApiUrl('marketing/setGiftsActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllGiftsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Gifts  - ',response);


    return AllGiftsUser;
};



const setDeletedGifts = async (id,val)=>{
    const response = await axios.post(buildApiUrl('marketing/setGiftsDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllGiftsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Gifts  - ',response);


    return AllGiftsUser;
};




const setUpdateGifts = async (dataGiftsUpdate)=>{
    const response = await axios.post(buildApiUrl('marketing/setGiftsUpdate/'),{
        dataGiftsUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllGiftsUser = data;

    //console.log('Сервер вернул данные по обновлению статуса Gifts  - ',dataGiftsUpdate,response);


    return AllGiftsUser;
};


const setSaveNewGifts = async (dataGiftsUpdate)=>{
    const response = await axios.post(buildApiUrl('marketing/setSaveNewGifts/'),{
        dataGiftsUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllGiftsUser = data;

    //console.log('Сервер вернул данные по обновлению статуса Gifts  - ',response, dataGiftsUpdate);


    return AllGiftsUser;
};

Mock.onGet('/api/marketing/getAllGifts').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllGiftsUser = await getAllGiftsUser();
    // console.log('С сервера пришло - ', AllGiftsUser);

    // if (!AllGiftsUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllGiftsUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllGiftsUser,
    ]


})


Mock.onPost('/api/marketing/setActiveGifts').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllGiftsUser = await setActiveGifts(id,val);

    // if (!AllGiftsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllGiftsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllGiftsUser,
    ]


})

Mock.onPost('/api/marketing/setDeletedGifts').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllGiftsUser = await setDeletedGifts(id,val);

    // if (!AllGiftsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllGiftsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllGiftsUser,
    ]


})


Mock.onPost('/api/marketing/setUpdateGifts').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataGiftsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Gifts = await setUpdateGifts(dataGiftsUpdate);

    // console.log('Серовер вернул данные ',AllGiftsUser);

    // if (!Gifts) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Gifts) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Gifts,
    ]


})


Mock.onPost('/api/marketing/setSaveNewGifts').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataGiftsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Gifts = await setSaveNewGifts(dataGiftsUpdate);

    // console.log('Серовер вернул данные ',AllGiftsUser);

    // if (!Gifts) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Gifts) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Gifts,
    ]
})